// import React, { useState, useEffect } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import Slidebar from './Slidebar';
// import Home from './Pages/Home';
// import CustomerReport from './Pages/CustomerReport';
// import BusOwnerManage from './Pages/BusOwnerManage';
// import BookingManage from './Pages/BookingManage';
// import PaymentReport from './Pages/PaymentReport';
// import CouponManage from './Pages/CouponManage';
// import InfluencerManage from './Pages/InfluencerManage';
// import OwnerCommission from './Pages/OwnerCommission';
// import Login from './Pages/Login';
// import ForgotPassword from './Pages/ForgotPassword';
// import '../Styles/AdminLaout.css';
// import InfluencerCommission from './Pages/InfluencerCommission';
// import ProfileManagement from './Pages/ProfileManagement';
// import { logout } from '../Redux/user_information';
// import RouteManage from './Pages/RouteManage';
// import TermsAndConditions from './Pages/TermsAndConditions';
// import DriverManagement from './Pages/DriverManagement';
// import ConductorManagement from './Pages/ConductorManagement';
// import SeatManagement from './Pages/SeatManagement';
// import BusFareChart from './Pages/BusFareChart';
// import EmployeeManagement from './Pages/EmployeeManagement';

// const AdminLayout = () => {
//   const [activeMenu, setActiveMenu] = useState('dashboard');
//   const [isSidebarCompact, setIsSidebarCompact] = useState(false);
//   const [showForgotPassword, setShowForgotPassword] = useState(false);

//   const dispatch = useDispatch();
//   const { token, loginData } = useSelector((state) => state.user);

//   const isLoggedIn = !!token;

//   const handleLogin = () => {

//   };

//   const handleLogout = () => {
//     dispatch(logout());
//     setActiveMenu('dashboard');
//     setShowForgotPassword(false);
//   };


//   const renderContent = () => {
//     if (!isLoggedIn) {
//       if (showForgotPassword) {
//         return <ForgotPassword onBackToLogin={() => setShowForgotPassword(false)} />;
//       }
//       return <Login onLogin={handleLogin} onForgotPassword={() => setShowForgotPassword(true)} />;
//     }

//     switch (activeMenu) {
//       case 'dashboard':
//         return <Home />;
//       case 'customers':
//         return <CustomerReport />;
//          case 'drivers':
//         return <DriverManagement />;
//          case 'conductors':
//         return <ConductorManagement />;
//       case 'bus-owners':
//         return <BusOwnerManage />;
//          case 'employees':
//         return <EmployeeManagement />;
//         case 'routes':
//         return <RouteManage />;
//       case 'bookings':
//         return <BookingManage />;
//       case 'payments':
//         return <PaymentReport />;
//       case 'coupons':
//         return <CouponManage />;
//       case 'influencers':
//         return <InfluencerManage />;
//       case 'owner-commissions':
//         return <OwnerCommission />;
//       case 'influencer-commissions':
//         return <InfluencerCommission />;
//          case 'seat-management':
//         return <SeatManagement />;
//       case 'profile':
//         return <ProfileManagement />;
//         case 'terms':
//         return <TermsAndConditions/>;
//         case 'chart':
//         return <BusFareChart/>;
//       default:
//         return <Home />;
//     }
//   };

//   return (
//     <div className="admin-layout">
//       {isLoggedIn && (
//         <Slidebar 
//           activeMenu={activeMenu} 
//           setActiveMenu={setActiveMenu}
//           onToggleCompact={setIsSidebarCompact}
//         />
//       )}

//       <main className={`admin-main ${isLoggedIn ? (isSidebarCompact ? 'compact-sidebar' : '') : 'full-width'}`}>
//         {isLoggedIn && (
//           <header className="admin-header">
//             <div className="header-right">
//               <div className="user-profile">
//                 <div className="profile-dropdown">
//                   <button 
//                     className="profile-btn"
//                     onClick={() => setActiveMenu('profile')}
//                   >
//                     <span>Profile</span>
//                   </button>
//                   <button className="logout-btn" onClick={handleLogout}>
//                     <span>Logout</span>
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </header>
//         )}

//         <div className="content-wrapper">
//           {renderContent()}
//         </div>
//       </main>
//     </div>
//   );
// };

// export default AdminLayout;

// import React, { useState, useEffect } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import Slidebar from './Slidebar';
// import Home from './Pages/Home';
// import CustomerReport from './Pages/CustomerReport';
// import BusOwnerManage from './Pages/BusOwnerManage';
// import BookingManage from './Pages/BookingManage';
// import PaymentReport from './Pages/PaymentReport';
// import CouponManage from './Pages/CouponManage';
// import InfluencerManage from './Pages/InfluencerManage';
// import OwnerCommission from './Pages/OwnerCommission';
// import Login from './Pages/Login';
// import ForgotPassword from './Pages/ForgotPassword';
// import '../Styles/AdminLaout.css';
// import InfluencerCommission from './Pages/InfluencerCommission';
// import ProfileManagement from './Pages/ProfileManagement';
// import { logout } from '../Redux/user_information';
// import RouteManage from './Pages/RouteManage';
// import TermsAndConditions from './Pages/TermsAndConditions';
// import DriverManagement from './Pages/DriverManagement';
// import ConductorManagement from './Pages/ConductorManagement';
// import SeatManagement from './Pages/SeatManagement';
// import BusFareChart from './Pages/BusFareChart';
// import EmployeeManagement from './Pages/EmployeeManagement';
// import FreelancerManagement from './Pages/FreelancerManagement';
// import ProfitReport from './Pages/ProfitReport';
// import AdminExpensesReport from './Pages/AdminExpensesReport';
// import GSTAdminPanel from './Pages/GSTAdminPanel';
// import MasterRouteManage from './Pages/MasterRouteManage';
// import GSTManagement from './Pages/GSTManagement';

// // Unauthorized Component
// const Unauthorized = ({ onGoBack }) => {
//   return (
//     <div style={{
//       textAlign: 'center',
//       padding: '50px',
//       maxWidth: '500px',
//       margin: '0 auto'
//     }}>
//       <div style={{
//         fontSize: '48px',
//         marginBottom: '20px',
//         color: '#dc3545'
//       }}>
//         ⚠️
//       </div>
//       <h2 style={{
//         color: '#dc3545',
//         marginBottom: '20px',
//         fontSize: '24px',
//         fontWeight: '600'
//       }}>
//         Unauthorized Access
//       </h2>
//       <p style={{
//         marginBottom: '30px',
//         color: '#666',
//         fontSize: '16px',
//         lineHeight: '1.6'
//       }}>
//         You don't have permission to access this page.
//         This area is restricted to administrators only.
//         Please contact your system administrator if you believe this is a mistake.
//       </p>
//       <button
//         onClick={onGoBack}
//         style={{
//           padding: '12px 30px',
//           backgroundColor: '#007bff',
//           color: 'white',
//           border: 'none',
//           borderRadius: '6px',
//           cursor: 'pointer',
//           fontSize: '16px',
//           fontWeight: '500',
//           transition: 'background-color 0.3s',
//           boxShadow: '0 2px 4px rgba(0,123,255,0.3)'
//         }}
//         onMouseEnter={(e) => e.target.style.backgroundColor = '#0056b3'}
//         onMouseLeave={(e) => e.target.style.backgroundColor = '#007bff'}
//       >
//         Go Back to Dashboard
//       </button>
//     </div>
//   );
// };

// const AdminLayout = () => {
//   const [activeMenu, setActiveMenu] = useState('dashboard');
//   const [isSidebarCompact, setIsSidebarCompact] = useState(false);
//   const [showForgotPassword, setShowForgotPassword] = useState(false);
//   const [showUnauthorized, setShowUnauthorized] = useState(false);

//   const dispatch = useDispatch();
//   const { token, loginData } = useSelector((state) => state.user);

//   const isLoggedIn = !!token;

//   // Get user role from loginData with fallback
//   const userRole = loginData?.user?.role || loginData?.role || 'admin';
//   const isAdmin = userRole?.toLowerCase() === 'admin';
//   const isFreelancer = userRole?.toLowerCase() === 'freelancer';

//   // Define allowed menus for different roles
//   const rolePermissions = {
//     admin: [
//       'dashboard', 'customers', 'drivers', 'conductors', 'bus-owners',
//       'employees', 'routes', 'bookings', 'payments', 'coupons',
//       'influencers', 'owner-commissions', 'profit-report', 'influencer-commissions',
//       'seat-management', 'profile', 'terms', 'chart', 'freelancers', 'expenses-report', 'GSTAdminPanel', 'masterroutes','GSTManagement'
//     ],
//     freelancer: [
//       'dashboard', 'drivers', 'conductors', 'bus-owners', 'routes', 'profile'
//     ]
//   };

//   // Get allowed menus based on user role
//   const getAllowedMenus = () => {
//     if (isAdmin) return rolePermissions.admin;
//     if (isFreelancer) return rolePermissions.freelancer;
//     return ['dashboard', 'profile']; // Default minimal access
//   };

//   const allowedMenus = getAllowedMenus();

//   const handleLogin = () => {
//     // Your login logic here
//     setActiveMenu('dashboard');
//     setShowUnauthorized(false);
//   };

//   const handleLogout = () => {
//     dispatch(logout());
//     setActiveMenu('dashboard');
//     setShowForgotPassword(false);
//     setShowUnauthorized(false);
//   };

//   // Check if user has access to the selected menu
//   const hasAccessToMenu = (menu) => {
//     return allowedMenus.includes(menu);
//   };

//   // Handle menu change with access check
//   const handleMenuChange = (menu) => {
//     if (hasAccessToMenu(menu)) {
//       setActiveMenu(menu);
//       setShowUnauthorized(false);
//     } else {
//       setShowUnauthorized(true);
//       // Optionally set a timeout to redirect back to dashboard
//       setTimeout(() => {
//         setShowUnauthorized(false);
//         setActiveMenu('dashboard');
//       }, 3000);
//     }
//   };

//   // Reset unauthorized state when component mounts or role changes
//   useEffect(() => {
//     setShowUnauthorized(false);
//     // Validate current active menu when role changes
//     if (isLoggedIn && !hasAccessToMenu(activeMenu) && activeMenu !== 'dashboard') {
//       setActiveMenu('dashboard');
//     }
//   }, [userRole, isLoggedIn]);

//   // Handle browser back/forward buttons
//   useEffect(() => {
//     const handlePopState = () => {
//       if (isLoggedIn && !hasAccessToMenu(activeMenu)) {
//         setActiveMenu('dashboard');
//       }
//     };

//     window.addEventListener('popstate', handlePopState);
//     return () => window.removeEventListener('popstate', handlePopState);
//   }, [activeMenu, isLoggedIn]);

//   const renderContent = () => {
//     // If not logged in, show login or forgot password
//     if (!isLoggedIn) {
//       if (showForgotPassword) {
//         return <ForgotPassword onBackToLogin={() => setShowForgotPassword(false)} />;
//       }
//       return <Login onLogin={handleLogin} onForgotPassword={() => setShowForgotPassword(true)} />;
//     }

//     // Show unauthorized page if trying to access restricted content
//     if (showUnauthorized) {
//       return <Unauthorized onGoBack={() => {
//         setShowUnauthorized(false);
//         setActiveMenu('dashboard');
//       }} />;
//     }

//     // Check if current active menu is allowed for current user
//     if (!hasAccessToMenu(activeMenu) && activeMenu !== 'dashboard') {
//       // Redirect to dashboard if trying to access unauthorized page directly
//       setActiveMenu('dashboard');
//       return <Home />;
//     }

//     // Render the appropriate component based on active menu
//     switch (activeMenu) {
//       case 'dashboard':
//         return <Home />;

//       case 'customers':
//         return isAdmin ? <CustomerReport /> : <Unauthorized onGoBack={() => setActiveMenu('dashboard')} />;

//         case 'GSTManagement':
//         return isAdmin ? <GSTManagement /> : <Unauthorized onGoBack={() => setActiveMenu('GSTManagement')} />;

//       case 'GSTAdminPanel':
//         return isAdmin ? <GSTAdminPanel /> : <Unauthorized onGoBack={() => setActiveMenu('GSTAdminPanel')} />;

//       case 'drivers':
//         return <DriverManagement />;

//       case 'conductors':
//         return <ConductorManagement />;

//       case 'bus-owners':
//         return <BusOwnerManage />;

//       case 'employees':
//         return isAdmin ? <EmployeeManagement /> : <Unauthorized onGoBack={() => setActiveMenu('dashboard')} />;
//       case 'freelancers':
//         return isAdmin ? <FreelancerManagement /> : <Unauthorized onGoBack={() => setActiveMenu('dashboard')} />;
//       case 'routes':
//         return <RouteManage />;
//       case 'masterroutes':
//         return <MasterRouteManage />;
//       case 'bookings':
//         return isAdmin ? <BookingManage /> : <Unauthorized onGoBack={() => setActiveMenu('dashboard')} />;

//       case 'payments':
//         return isAdmin ? <PaymentReport /> : <Unauthorized onGoBack={() => setActiveMenu('dashboard')} />;

//       case 'coupons':
//         return isAdmin ? <CouponManage /> : <Unauthorized onGoBack={() => setActiveMenu('dashboard')} />;

//       case 'influencers':
//         return isAdmin ? <InfluencerManage /> : <Unauthorized onGoBack={() => setActiveMenu('dashboard')} />;

//       case 'owner-commissions':
//         return isAdmin ? <OwnerCommission /> : <Unauthorized onGoBack={() => setActiveMenu('dashboard')} />;

//       case 'profit-report':
//         return isAdmin ? <ProfitReport /> : <Unauthorized onGoBack={() => setActiveMenu('dashboard')} />;
//       case 'expenses-report':
//         return isAdmin ? <AdminExpensesReport /> : <Unauthorized onGoBack={() => setActiveMenu('dashboard')} />;

//       case 'influencer-commissions':
//         return isAdmin ? <InfluencerCommission /> : <Unauthorized onGoBack={() => setActiveMenu('dashboard')} />;

//       case 'seat-management':
//         return isAdmin ? <SeatManagement /> : <Unauthorized onGoBack={() => setActiveMenu('dashboard')} />;

//       case 'profile':
//         return <ProfileManagement />;

//       case 'terms':
//         return isAdmin ? <TermsAndConditions /> : <Unauthorized onGoBack={() => setActiveMenu('dashboard')} />;

//       case 'chart':
//         return isAdmin ? <BusFareChart /> : <Unauthorized onGoBack={() => setActiveMenu('dashboard')} />;

//       default:
//         return <Home />;
//     }
//   };

//   // Get user display name or email for header
//   const getUserDisplayName = () => {
//     if (loginData?.user?.name) return loginData.user.name;
//     if (loginData?.name) return loginData.name;
//     if (loginData?.user?.email) return loginData.user.email;
//     if (loginData?.email) return loginData.email;
//     return 'User';
//   };

//   // Get role badge color
//   const getRoleBadgeStyle = () => {
//     if (isAdmin) {
//       return {
//         backgroundColor: '#28a745',
//         color: 'white',
//         padding: '4px 12px',
//         borderRadius: '20px',
//         fontSize: '12px',
//         fontWeight: '600',
//         marginRight: '15px'
//       };
//     }
//     if (isFreelancer) {
//       return {
//         backgroundColor: '#ffc107',
//         color: '#212529',
//         padding: '4px 12px',
//         borderRadius: '20px',
//         fontSize: '12px',
//         fontWeight: '600',
//         marginRight: '15px'
//       };
//     }
//     return {
//       backgroundColor: '#6c757d',
//       color: 'white',
//       padding: '4px 12px',
//       borderRadius: '20px',
//       fontSize: '12px',
//       fontWeight: '600',
//       marginRight: '15px'
//     };
//   };

//   return (
//     <div className="admin-layout">
//       {isLoggedIn && (
//         <Slidebar
//           activeMenu={activeMenu}
//           setActiveMenu={handleMenuChange}
//           onToggleCompact={setIsSidebarCompact}
//           userRole={userRole}
//           allowedMenus={allowedMenus}
//           isAdmin={isAdmin}
//           isFreelancer={isFreelancer}
//         />
//       )}

//       <main className={`admin-main ${isLoggedIn ? (isSidebarCompact ? 'compact-sidebar' : '') : 'full-width'}`}>
//         {isLoggedIn && (
//           <header className="admin-header" style={{
//             display: 'flex',
//             justifyContent: 'flex-end',
//             alignItems: 'center',
//             padding: '0 30px',
//             height: '70px',
//             backgroundColor: 'white',
//             boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
//             position: 'sticky',
//             top: 0,
//             zIndex: 100
//           }}>
//             <div className="header-right" style={{
//               display: 'flex',
//               alignItems: 'center',
//               gap: '20px'
//             }}>
//               {/* User Role Badge */}
//               <span style={getRoleBadgeStyle()}>
//                 {isAdmin ? '👑 Admin' : isFreelancer ? '🔧 Freelancer' : '👤 User'}
//               </span>

//               {/* User Profile Dropdown */}
//               <div className="user-profile" style={{
//                 position: 'relative'
//               }}>
//                 <div className="profile-dropdown" style={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: '10px'
//                 }}>
//                   <span style={{
//                     color: '#333',
//                     fontSize: '14px',
//                     fontWeight: '500'
//                   }}>
//                     {getUserDisplayName()}
//                   </span>
//                   <button
//                     className="profile-btn"
//                     onClick={() => handleMenuChange('profile')}
//                     style={{
//                       padding: '8px 16px',
//                       backgroundColor: '#f8f9fa',
//                       border: '1px solid #dee2e6',
//                       borderRadius: '4px',
//                       color: '#333',
//                       cursor: 'pointer',
//                       fontSize: '14px',
//                       fontWeight: '500',
//                       transition: 'all 0.3s'
//                     }}
//                     onMouseEnter={(e) => {
//                       e.target.style.backgroundColor = '#e9ecef';
//                       e.target.style.borderColor = '#ced4da';
//                     }}
//                     onMouseLeave={(e) => {
//                       e.target.style.backgroundColor = '#f8f9fa';
//                       e.target.style.borderColor = '#dee2e6';
//                     }}
//                   >
//                     Profile
//                   </button>
//                   <button
//                     className="logout-btn"
//                     onClick={handleLogout}
//                     style={{
//                       padding: '8px 16px',
//                       backgroundColor: '#dc3545',
//                       border: 'none',
//                       borderRadius: '4px',
//                       color: 'white',
//                       cursor: 'pointer',
//                       fontSize: '14px',
//                       fontWeight: '500',
//                       transition: 'background-color 0.3s'
//                     }}
//                     onMouseEnter={(e) => e.target.style.backgroundColor = '#c82333'}
//                     onMouseLeave={(e) => e.target.style.backgroundColor = '#dc3545'}
//                   >
//                     Logout
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </header>
//         )}

//         <div className="content-wrapper" style={{
//           padding: '30px',
//           backgroundColor: '#f8f9fa',
//           minHeight: isLoggedIn ? 'calc(100vh - 70px)' : '100vh'
//         }}>
//           {renderContent()}
//         </div>
//       </main>
//     </div>
//   );
// };

// export default AdminLayout;

import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import Slidebar from './Slidebar';
import { logout } from '../Redux/user_information';
import '../Styles/AdminLaout.css';

const AdminLayout = () => {
  const [isSidebarCompact, setIsSidebarCompact] = useState(false);
  
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { token, loginData } = useSelector((state) => state.user);

  const isLoggedIn = !!token;
  const userRole = loginData?.user?.role || loginData?.role || 'admin';
  const isAdmin = userRole?.toLowerCase() === 'admin';
  const isFreelancer = userRole?.toLowerCase() === 'freelancer';

  // Define allowed menus for different roles
  const rolePermissions = {
    admin: [
      'dashboard', 'customers', 'drivers', 'conductors', 'bus-owners',
      'employees', 'routes', 'bookings', 'payments', 'coupons',
      'influencers', 'owner-commissions', 'profit-report', 'influencer-commissions',
      'seat-management', 'profile', 'terms', 'chart', 'freelancers', 'expenses-report', 
      'GSTAdminPanel', 'masterroutes', 'GSTManagement', 'master-routes', 'gst-management', 'customer-care',
      'gst-admin-panel', 'bus-fare-chart',"platform-management",'BusManagement','BookingPolicyManagement','busroutes'
    ],
    freelancer: [
      'dashboard', 'drivers', 'conductors', 'bus-owners', 'routes', 'profile'
    ]
  };

  // Get allowed menus based on user role
  const getAllowedMenus = () => {
    if (isAdmin) return rolePermissions.admin;
    if (isFreelancer) return rolePermissions.freelancer;
    return ['dashboard', 'profile']; // Default minimal access
  };

  const allowedMenus = getAllowedMenus();

  // Check if user has access to current route
  const hasAccessToRoute = (path) => {
    const currentMenu = path.substring(1) || 'dashboard';
    return allowedMenus.includes(currentMenu);
  };

  // Redirect if no access
  useEffect(() => {
    if (isLoggedIn && !hasAccessToRoute(location.pathname)) {
      navigate('/dashboard');
    }
  }, [location.pathname, isLoggedIn, navigate]);

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  // Get user display name or email for header
  const getUserDisplayName = () => {
    if (loginData?.user?.name) return loginData.user.name;
    if (loginData?.name) return loginData.name;
    if (loginData?.user?.email) return loginData.user.email;
    if (loginData?.email) return loginData.email;
    return 'User';
  };

  // Get role badge color
  const getRoleBadgeStyle = () => {
    if (isAdmin) {
      return {
        backgroundColor: '#28a745',
        color: 'white',
        padding: '4px 12px',
        borderRadius: '20px',
        fontSize: '12px',
        fontWeight: '600',
        marginRight: '15px'
      };
    }
    if (isFreelancer) {
      return {
        backgroundColor: '#ffc107',
        color: '#212529',
        padding: '4px 12px',
        borderRadius: '20px',
        fontSize: '12px',
        fontWeight: '600',
        marginRight: '15px'
      };
    }
    return {
      backgroundColor: '#6c757d',
      color: 'white',
      padding: '4px 12px',
      borderRadius: '20px',
      fontSize: '12px',
      fontWeight: '600',
      marginRight: '15px'
    };
  };

  // Don't render anything if not logged in
  if (!isLoggedIn) {
    return null;
  }

  return (
    <div className="admin-layout">
      <Slidebar
        activeMenu={location.pathname.substring(1) || 'dashboard'}
        setActiveMenu={(menu) => navigate(`/${menu}`)}
        onToggleCompact={setIsSidebarCompact}
        userRole={userRole}
        allowedMenus={allowedMenus}
        isAdmin={isAdmin}
        isFreelancer={isFreelancer}
      />

      <main className={`admin-main ${isSidebarCompact ? 'compact-sidebar' : ''}`}>
        <header className="admin-header" style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          padding: '0 30px',
          height: '70px',
          backgroundColor: 'white',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          position: 'sticky',
          top: 0,
          zIndex: 100
        }}>
          <div className="header-right" style={{
            display: 'flex',
            alignItems: 'center',
            gap: '20px'
          }}>
            {/* User Role Badge */}
            <span style={getRoleBadgeStyle()}>
              {isAdmin ? '👑 Admin' : isFreelancer ? '🔧 Freelancer' : '👤 User'}
            </span>

            {/* User Profile Dropdown */}
            <div className="user-profile" style={{
              position: 'relative'
            }}>
              <div className="profile-dropdown" style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}>
                <span style={{
                  color: '#333',
                  fontSize: '14px',
                  fontWeight: '500'
                }}>
                  {getUserDisplayName()}
                </span>
                <button
                  className="profile-btn"
                  onClick={() => navigate('/profile')}
                  style={{
                    padding: '8px 16px',
                    backgroundColor: '#f8f9fa',
                    border: '1px solid #dee2e6',
                    borderRadius: '4px',
                    color: '#333',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '500',
                    transition: 'all 0.3s'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#e9ecef';
                    e.target.style.borderColor = '#ced4da';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#f8f9fa';
                    e.target.style.borderColor = '#dee2e6';
                  }}
                >
                  Profile
                </button>
                <button
                  className="logout-btn"
                  onClick={handleLogout}
                  style={{
                    padding: '8px 16px',
                    backgroundColor: '#dc3545',
                    border: 'none',
                    borderRadius: '4px',
                    color: 'white',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '500',
                    transition: 'background-color 0.3s'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#c82333'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = '#dc3545'}
                >
                  Logout
                </button>
              </div>
            </div>
          </div>
        </header>

        <div className="content-wrapper" style={{
          padding: '30px',
          backgroundColor: '#f8f9fa',
          minHeight: 'calc(100vh - 70px)'
        }}>
          <Outlet /> {/* This renders the matched route component */}
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;